/* istanbul ignore file - better tested e2e */

import { useQueryParams } from '@partful/shared/lib/hooks/useQueryParams';
import { Redirect, Route, Switch } from 'react-router';
import { VersionsPage } from './root';
import { VersionPage } from './version/VersionPage';

export function VersionsPageRouter() {
  const { productName } = useQueryParams();

  return (
    <Switch>
      <Route exact path="/instructions/manage/:configurationId/versions">
        <VersionsPage />
      </Route>
      <Route exact path="/instructions/manage/:configurationId/versions/:versionId">
        <VersionPage />
      </Route>
      <Route
        path="/instructions/manage/:configurationId/versions"
        render={({ match }) => (
          <Redirect to={`/instructions/manage/${match.params.configurationId}/versions?productName=${productName}`} />
        )}
      />
    </Switch>
  );
}
